import React from 'react';
import roomsPng from '../../assets/Rooms.png';

type RoomsGlyphProps = {
  className?: string;
  size?: number; // optional pixel size override
};

export const RoomsGlyph: React.FC<RoomsGlyphProps> = ({ className, size }) => {
  const dimensionStyle = size ? { width: size, height: size } : undefined;
  return (
    <span
      className={className}
      style={{
        ...dimensionStyle,
        display: 'inline-block',
        backgroundColor: 'currentColor',
        WebkitMaskImage: `url(${roomsPng})`,
        maskImage: `url(${roomsPng})`,
        WebkitMaskRepeat: 'no-repeat',
        maskRepeat: 'no-repeat',
        WebkitMaskSize: 'contain',
        maskSize: 'contain',
        WebkitMaskPosition: 'center',
        maskPosition: 'center',
      }}
      aria-hidden="true"
    />
  );
};

export default RoomsGlyph;
